module.exports = function getResource(label, vars = []) {
    const resources = {
        default: 'Par défaut',
        sort: 'Trier',
        sortBy: 'Trier par'
    };

    return resources[label];
};
